import { Alert } from "antd";
import { useQuota } from "hooks/useQuota";
import { useTranslate } from "#src/hooks";

interface QuotaWarningProps {
  readonly feature: string;
  readonly warningThreshold?: number;
}

export function QuotaWarning({
  feature,
  warningThreshold = 0.8,
}: QuotaWarningProps) {
  const { getQuota, isNearLimit, isLoading, isBlocked } = useQuota();
  const t = useTranslate();

  if (isLoading) return null;

  const quota = getQuota(feature);

  if (!quota || quota.quota_limit === null) return null;

  if (isBlocked(feature)) {
    return (
      <Alert
        showIcon
        type="error"
        message={t("quota.featureBlocked")}
        description={t("quota.blockedMessage", {
          feature,
          usage: quota?.usage,
          limit: quota?.quota_limit,
        })}
      />
    );
  }

  const showWarning = isNearLimit(feature, warningThreshold);

  if (!showWarning) return null;

  return (
    <Alert
      showIcon
      type="warning"
      message={t("quota.approachingLimit")}
      description={t("quota.usage", {
        usage: quota.usage,
        limit: quota.quota_limit,
      })}
    />
  );
}
